import { t } from "i18next";

export const formatValidationAlerts = (validHeadings, invalidHeadings) => {
  const alerts = [];
  if (validHeadings) {
    alerts.push({
      type: "success",
      title: t("importTool:import.alerts.validHeadings"),
      description: validHeadings,
    });
  }
  if (invalidHeadings) {
    alerts.push({
      type: "warning",
      title: t("importTool:import.alerts.ignoredHeadings"),
      description: invalidHeadings,
    });
  }
  return alerts;
};

export const formatInvalidHeadingsAlert = (error) => {
  return [
    {
      type: "error",
      title: t("importTool:import.alerts.invalidHeadings"),
      description: error,
    },
  ];
};

export const formatInsertSuccessAlert = (insertedCount) => {
  const description = t(`importTool:import.alerts.rowInserted`, {
    count: insertedCount,
  });

  return [
    {
      type: "success",
      title: t("importTool:import.alerts.successTitle"),
      description: description,
    },
  ];
};

export const formatUpdateSuccessAlert = (updatedCount, ignoredCount) => {
  const rowUpdated = t(`importTool:import.alerts.rowUpdated`, {
    count: updatedCount,
  });
  const rowIgnored = t(`importTool:import.alerts.rowIgnored`, {
    count: ignoredCount,
  });

  return [
    {
      type: "success",
      title: t("importTool:import.alerts.successTitle"),
      description: rowUpdated,
    },
    {
      type: "warning",
      description: rowIgnored,
    },
  ];
};

export const formatErrorsAlerts = (errors) => {
  const alerts = [];
  for (const [attribute, messages] of Object.entries(errors)) {
    alerts.push({
      type: "error",
      title: t("importTool:import.alerts.errorTitle", {
        count: messages.length,
        attribute,
      }),
      description: messages.join("\n"),
    });
  }
  return alerts;
};
